export const getDisableCacheAppendix = function (url) {
  return url + '?timeStamp=' + new Date().getTime();
};
